<div class="login-page theme-main">
    <img class="login-page-back" src="/assets/img/Home-Slide-Peak-Top.jpg" />
    <div class="login-container">
        <img class="login-img" src="/assets/img/peak-gelisim-logo.png">
        <h4 class="mt-4">Giriş Yapın</h4>
        <div *ngIf="hasError">
            <alert type="danger" [dismissible]="true" (onClosed)="hasError = false; errorMessage = '';">
                {{ errorMessage }}</alert>
        </div>
        <div *ngIf="isLoading">
            <alert type="success" [dismissible]="false"><i class="fa fa-spin fa-spinner"></i> Bilgileriniz kontrol ediliyor, lütfen bekleyiniz</alert>
        </div>
        <form class="login-form needs-validation" name="form" (ngSubmit)="f.form.valid && login()" #f="ngForm">
            <div class="row mb-3">
                <!-- <div class="col-md-6">
                    <label class="form-text">Kurum Kodu <span class="required">*</span></label>
                    <input autocomplete="off" pattern="[0-9]*" inputmode="numeric" digitOnly type="text" maxlength="5" name="TenantCode" class="form-control" [(ngModel)]="loginInfo.TenantCode" placeholder="Kurum kodu" #TenantCode="ngModel" [class.is-invalid]="f.submitted && TenantCode.invalid"
                        (keyup.enter)="login()" required />
                    <div *ngIf="f.submitted && TenantCode.invalid" class="invalid-feedback">
                        Lütfen kurum kodu giriniz.
                    </div>
                </div> -->
                <div class="col-md-12   ">
                    <label class="form-text">E-posta Adresi <span class="required"> *</span></label>
                    <input type="text" autocomplete="off" name="Username" class="form-control" [(ngModel)]="loginInfo.Username" placeholder="E-posta Adresi" #Username="ngModel" [class.is-invalid]="f.submitted && Username.invalid"
                        (keyup.enter)="login()" required />
                    <div *ngIf="f.submitted && Username.invalid" class="invalid-feedback">
                        Lütfen e-posta adresi giriniz.
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-12">
                    <label class="form-text">Şifre <span class="required">*</span></label>
                    <input autocomplete="off" type="password" name="Password" class="form-control" [(ngModel)]="loginInfo.Password" placeholder="Şifre" (keyup.enter)="login()" #Password="ngModel" [class.is-invalid]="f.submitted && Password.invalid" required />
                    <div *ngIf="f.submitted && Password.invalid" class="invalid-feedback">
                        Lütfen şifre giriniz.
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-12">
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="remember-me" [checked]="loginInfo.RememberMe" (change)="loginInfo.RememberMe = !loginInfo.RememberMe">
                        <label class="form-check-label" for="remember-me">Beni Hatırla</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12" style="padding-top: 10px;">
                    <button class="btn btn-primary card2-button1 login-button" style="float: right;" type="button" (click)="login()" [disabled]="isLoading || f.form.valid == false">
                        Giriş Yap
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>